import { Navbar } from "@components/block/navbar";
import { Sidebar } from "@components/kit/sidebar";
import { Container } from "@components/ui/structure/container";
import { ContentFrame } from "@components/ui/structure/content-frame";
import { Top } from "@components/ui/structure/top";
import { HomeView } from "@components/view/home-view";
import { ErrorView } from "@components/view/not-found-view";
import { ChatProvider } from "@contexts/chat";
import { UserProvider } from "@contexts/user";
import { AuthPage } from "@routes/auth";
import { ProfilePage } from "@routes/profile";
import { ReportPage } from "@routes/report";
import { useClasses } from "@styles";
import { useForwarded } from "@utils/path";
import { type LayoutProps, useRouter } from "@utils/router";

function Layout({
  forwarded = [],
  dynamic = "",
  children
}: LayoutProps) {
  let path = "";

  if (dynamic)
    path = `/${dynamic}`;

  if (forwarded?.length)
    path += `/${forwarded?.join('/')}`;

  return (<>
    <UserProvider>
      <Container attributes={{ id: "main" }}>
        <ContentFrame>
          <Top />
          <Navbar path={path} />
          <Container className={useClasses('home-view')}>
            <ChatProvider>
              <Container className={useClasses("home-view-body")}>
                <Sidebar />
                {children}

                {!children && dynamic && (
                  <ErrorView
                    code={404}
                    message={`Can't reach: ${path}`}
                  />
                )}

                {!children && !dynamic && <HomeView />}
              </Container>
            </ChatProvider>
          </Container>
        </ContentFrame>
      </Container>
    </UserProvider>
  </>);
}

export function IndexPage() {
  return useRouter(useForwarded(), Layout, {
    "auth": AuthPage,
    "profile": ProfilePage,
    "report": ReportPage,
  });
}

